import React, { Fragment, useEffect, useState } from 'react'
import { useTranslate, useNotify, useRedirect, } from 'react-admin'
import { CircularProgress, Button, TextField, Grid, Typography, Icon, FormHelperText, FormControl, MenuItem, Select } from '@mui/material'
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service';


const BANK_FILENAME_MAP = {
  PATARS: 'banco_patagonia',
  RIOARS: 'banco_santander_pesos',
  RIOUSD: 'banco_santander_dolares',
  BASEUSD: 'banco_base_dolares',
  BASEMXN: 'banco_base_pesos_mex', 
  MACROUSD: 'banco_macro_dolares',
}


function BillingFormExtractsDownload() {
	const notify = useNotify()
	const translate = useTranslate()
	const redirect = useRedirect();


	const [selectedBank, setSelectedBank] = useState("0");
	const [errorWithSelectBank, setErrorWithSelectBank] = useState(false);
	const [sendRequest, setSendRequest] = useState(false);

	// Estado para guardar el blob y su URL de descarga
	const [downloadUrl, setDownloadUrl] = useState(null);



	useEffect(() => {
		return () => {
			if (downloadUrl) {
				URL.revokeObjectURL(downloadUrl);
			}
		};
	}, [downloadUrl]);

	const handleGetExtract = async () => {
		if (selectedBank === "0") {
			setErrorWithSelectBank(true);
			return;
		}

		setErrorWithSelectBank(false);
		setSendRequest(true);

		try {
			const query = `bank_name=${selectedBank}`;
			const response = await billingFormServices.getExtract(query);
			// Crear URL del Blob y guardarlo en el estado
			const fileURL = URL.createObjectURL(response);
			setDownloadUrl(fileURL);

			notify(translate('ra.message.extract_download_available'), { type: 'success' });
		} catch (error) {
			notify(error.response?.data?.detail ?? translate('ra.message.extract_download_error'), { type: 'error' });
		} finally {
			setSendRequest(false);
		}
	};

	return (
		<div className='conciliationExtractContainer'>
			<div className='message'><Typography variant="body2" color="textSecondary" component="span">{translate('ra.message.select_fields_generate_extract_file')}</Typography></div>
			<div className='container'>
				<Grid container spacing={3}>
					<Grid item md={5} className='downloadButton'>
						{downloadUrl &&
							<Button
								disabled={sendRequest}
								startIcon={<Icon>download</Icon>}
								variant="outlined"
								color="success"
								component="a"
								href={downloadUrl || '#'}
								download={`extracto_${BANK_FILENAME_MAP[selectedBank] ?? 'banco_default'}.xlsx`}
							>
								{translate('ra.field.download_extract')}
							</Button>
						}
					</Grid>
					<Grid item md={5} >
						<div className="inputlabel">{translate('ra.field.bank')}:</div>
						<FormControl fullWidth variant='outlined' size='small' className='generalComponentSelect' error={errorWithSelectBank}>
							<Select
								id="selectBank"
								value={selectedBank}
								onChange={(e) => setSelectedBank(e.target.value)}
								variant="outlined"
								size="small"
							>
								<MenuItem key={1} value="0">
									<em className="selectOptionDisabled">{translate('ra.action.select_with_dots')}</em>
								</MenuItem>
								<MenuItem key={2} value={'PATARS'}>Banco Patagonia</MenuItem>
								<MenuItem key={3} value={'RIOARS'}>Banco Santander (pesos)</MenuItem>
								<MenuItem key={4} value={'RIOUSD'}>Banco Santander (dólares)</MenuItem>
								<MenuItem key={3} value={'BASEUSD'}>Banco Base (dólares)</MenuItem>
								<MenuItem key={4} value={'BASEMXN'}>Banco Base (pesos mexicanos)</MenuItem>
								<MenuItem key={3} value={'MACUSD'}>Banco Macro (dólares)</MenuItem>
							</Select>
							{errorWithSelectBank && <FormHelperText className='componenteHelperText' error>{translate('ra.validation.required')}</FormHelperText>}
						</FormControl>
					</Grid>
					<Grid className="sendButton" item md={1} style={{ paddingBottom: '2px' }} >
						<Button disabled={sendRequest} fullwidth onClick={() => handleGetExtract()} startIcon={sendRequest ? <CircularProgress size={20} color="primary" /> : <Icon>send</Icon>}
							variant="contained" color="primary" >{translate('ra.action.send')}</Button>
					</Grid>
				</Grid>
			</div>
		</div>
	)
}

export default BillingFormExtractsDownload